<template>
  <div class="report">
    <!-- 筛选和搜索区域 -->
    <div class="search">
      <el-form label-width="80px">
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="状态:" @change="handleStatusChange">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待处理" value="0"></el-option>
            <el-option label="已处理" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form label-width="80px">
        <el-form-item label="搜索">
          <div style="display: flex;align-items: center;flex-direction: row;justify-content: flex-start;">
            <el-select v-model="queryType" placeholder="搜索" style="margin-right: 10px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="举报人ID" value="1"></el-option>
              <el-option label="举报人昵称" value="2"></el-option>
              <el-option label="被举报人ID" value="3"></el-option>
              <el-option label="被举报人昵称" value="4"></el-option>
              <el-option label="业务信息" value="5"></el-option>
            </el-select>
            <el-input style="width: 200px;" v-model="queryContent" placeholder="请输入搜索内容"></el-input>
            <img class="search-icon" src="/img/search-icon.png" @click="handleSearch" />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表区域 -->
    <div class="list-container">
      <div v-for="item in needList" :key="item.id" class="report-item">
        <div class="item-header">
          <div class="item-info">
            <div class="info-row">
              <span class="label">举报人ID:</span>
              <span class="value">{{ item.reporterId }}</span>
            </div>
            <div v-if="item.reporterNickName" class="info-row">
              <span class="label">举报人昵称:</span>
              <span class="value">
                <el-button type="text" @click="openPersonalDetail(item.reporterEmployeeId)">
                  {{ item.reporterNickName }}
                </el-button>
              </span>
            </div>
            <div class="info-row">
              <span class="label">被举报人ID:</span>
              <span class="value">{{ item.reportedId }}</span>
            </div>
            <div v-if="item.reportedNickName" class="info-row">
              <span class="label">被举报人昵称:</span>
              <span class="value">
                <el-button type="text" @click="openPersonalDetail(item.reportedEmployeeId)">
                  {{ item.reportedNickName }}
                </el-button>
              </span>
            </div>
            <div v-if="item.businessInfo" class="info-row">
              <span class="label">业务信息:</span>
              <span class="value">{{ item.businessInfo }}</span>
            </div>
            <div v-if="item.position" class="info-row">
              <span class="label">举报人位置:</span>
              <span class="value">
                <el-button type="text" @click="openReportPosition(item.positionUrl, item.businessInfo)">
                  {{ item.position }}
                </el-button>
              </span>
            </div>
          </div>
        </div>

        <!-- 举报时间和状态信息 -->
        <div class="status-info">
           <!-- 举报类型 -->
           <div v-if="item.type" class="info-row">
            <span class="label">举报类型:</span>
            <span class="value">{{ item.type }}</span>
          </div>

          <!-- 举报描述 -->
          <div v-if="item.description" class="info-row">
            <span class="label">举报描述:</span>
            <span class="value">{{ item.description }}</span>
          </div>
          <div class="info-row">
            <span class="label">举报时间:</span>
            <span class="value">{{ item.createTime }}</span>
          </div>

          <!-- 处理结果 -->
          <div class="info-row">
            <span class="label">处理结果:</span>
            <span class="value">
              <el-input
                v-if="item.status === 0"
                v-model="dealResults[item.id]"
                placeholder="请输入处理结果"
                type="textarea"
                :rows="3"
                maxlength="300"
                show-word-limit
                style="width: 400px;"
              ></el-input>
              <span v-else>{{ item.dealResult }}</span>
            </span>
          </div>

          <div class="info-row">
            <span class="label">状态:</span>
            <span class="value">
              <el-tag :type="getStatusType(item.status)">
                {{ getStatusText(item.status) }}
              </el-tag>
            </span>
          </div>

          <!-- 处理人 -->
          <div v-if="item.status !== 0" class="info-row">
            <span class="label">处理人:</span>
            <span class="value">{{ item.dealUserId }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div v-if="item.status === 0" class="action-buttons">
          <el-button type="primary" @click="handleProcess(item)">置已处理</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getReportList, reportPassed} from '../../api/background'

export default {
  name: 'Report',
  props: {
    needList: {
      type: Array,
      default: () => []
    },
    pageNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      reportList: [],
      status: '-1',
      queryType: '-1',
      queryContent: '',
      dealResults: {} // 存储每个举报的处理结果
    }
  },
  watch: {
    // status() {
    //   console.log(111);
    //   this.getReportList(1)
    // },
    queryType() {
      this.getReportList(this.pageNum)
    },
    pageNum(val) {
      this.getReportList(val)
    }
  },
  created() {
    this.getReportList(this.pageNum)
  },
  methods: {
    // 获取举报列表
    getReportList(page) {
      const params = {
        status: this.status || '-1',
        queryType: this.queryType === '-1' ? '-1' : this.queryType,
        queryContent: this.queryContent,
        pageNum: page || 1
      }

      getReportList(params)
        .then(res => {
          this.reportList = res.data.records || []
          this.$emit('updatePendingTotal', res.data.pendingTotal || 0)
        })
        .catch(err => {
          console.error('获取举报列表失败:', err)
          this.$message.error('获取数据失败')
        })
    },

    // 状态筛选变化
    handleStatusChange() {
      this.getReportList(this.pageNum)
    },

    // 搜索
    handleSearch() {
      // if (this.queryType === '-1' && this.queryContent) {
      //   this.$message.error('请选择搜索类型')
      //   return
      // }
      this.getReportList(this.pageNum)

    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        0: 'warning', // 待处理
        1: 'success' // 已处理
      }
      return statusMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已处理'
      }
      return statusMap[status] || '未知'
    },

    // 打开个人详情页
    openPersonalDetail(employeeId) {
      if (!employeeId) {
        this.$message.warning('该用户未入驻')
        return
      }
      const routeData = this.$router.resolve({
        path: `/personal/detail/${employeeId}` // 例如 '/detail'
      })

      window.open(routeData.href, '_blank')
    },

    // 打开举报位置页面
    openReportPosition(positionUrl, businessInfo) {
      if (!positionUrl) {
        this.$message.warning('位置链接无效')
        return
      }

      // 从业务信息中提取ID（格式：受询人ID:1）
      const routeConfig = {
        path: positionUrl
      }

      if (businessInfo) {
        const idMatch = businessInfo.match(/ID[：:]\s*(\d+)/)
        if (idMatch && idMatch[1]) {
          routeConfig.query = {
            consultant_id: idMatch[1]
          }
        }
      }

      // 使用路由解析获取完整URL，然后在新标签页打开
      const routeData = this.$router.resolve(routeConfig)
      window.open(routeData.href, '_blank')
    },

    // 置已处理
    handleProcess(item) {
      const dealResult = this.dealResults[item.id]
      if (!dealResult || dealResult.trim() === '') {
        this.$message.error('请输入处理结果')
        return
      }

      if (dealResult.length > 300) {
        this.$message.error('处理结果不能超过300字')
        return
      }

      this.$confirm('确认设置为已处理吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          reportPassed({
            id: item.id,
            dealResult: dealResult.trim()
          })
            .then(() => {
              this.$message.success('操作成功')
              this.getReportList(this.pageNum)
              this.$emit('refreshNeedList')
            })
            .catch(err => {
              console.error('设置已处理失败:', err)
              this.$message.error('操作失败')
            })
        })
        .catch(() => {
          // 用户取消
        })
    }
  }
}
</script>

<style scoped>
.report {
  padding: 20px;
}

.search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.search-icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-left: 20px;
}

.list-container {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.report-item {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  padding: 20px;
}

.report-item:last-child {
  border-bottom: 1px solid #e4e7ed;
}

.item-header {
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.label {
  min-width: 100px;
  font-weight: 500;
  color: #606266;
  flex-shrink: 0;
}

.value {
  color: #303133;
  flex: 1;
  word-break: break-all;
  margin-left: 10px;
}

.status-info {
  margin: 15px 0;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}

.action-buttons .el-button {
  margin-left: 10px;
}
</style>
